import React from 'react';

// Action popup for a marker (view / delete / close).
//
// Markers live inside the zoomable `scale(zoom)` drawing layer so their position
// follows the image, but this popup is chrome: it must stay the same physical
// size at every zoom level. The inverse `scale(1 / zoom)` cancels the parent
// transform, and `transformOrigin: 'top left'` pins it to the marker anchor
// (left: 50%, top: 100%) so the translate keeps it centred under the marker and
// the 4px gap stays constant on screen — hence no `-translate-x-1/2`/`mt-1`,
// which would be scaled by the parent.
export const MarkerActionsPopup = ({ zoom = 1, children, ...rest }) => {
  const inverse = 1 / (Number(zoom) || 1);
  return (
    <div
      className="marker-popup absolute top-full left-1/2 flex gap-1 bg-slate-800 rounded-md shadow-lg p-1"
      style={{
        zIndex: 9999,
        transform: `scale(${inverse}) translate(-50%, 4px)`,
        transformOrigin: 'top left',
      }}
      onClick={(e) => e.stopPropagation()}
      data-testid="marker-actions-popup"
      {...rest}
    >
      {children}
    </div>
  );
};

export default MarkerActionsPopup;
